import {
  BaseClass,
  IGraph,
  ILabel,
  ILabelModel,
  ILabelModelParameter,
  ILookup,
  INode,
  IOrientedRectangle,
  OrientedRectangle,
  Rect,
} from '@ardoq/yfiles';
import type { CollapsibleGraphGroup, YGraphState } from '@ardoq/graph';
import {
  MODERNIZED_BLOCK_DIAGRAM_EXPANDER_SIZE as EXPANDER_SIZE,
  MODERNIZED_BLOCK_DIAGRAM_GROUP_PADDING as PADDING,
} from '../consts';
import { ensureHeaderLayout } from '../ensureHeaderLayout';
import { LabelModelParameter } from '../LabelModelParameter';

class GroupSubLabelModel extends BaseClass(ILabelModel) {
  constructor(private graph: IGraph) {
    super();
  }
  createParameter(): ILabelModelParameter {
    return new LabelModelParameter(this);
  }
  override getContext(_label: ILabel): ILookup {
    return ILookup.EMPTY;
  }
  override getGeometry(
    label: ILabel,
    _layoutParameter: ILabelModelParameter
  ): IOrientedRectangle {
    const { owner } = label;
    const node = owner as INode | null;
    if (!node) {
      return IOrientedRectangle.EMPTY;
    }
    const {
      tag,
      layout: { x: nodeX, y: nodeY, width: nodeWidth },
    } = node;
    const graphGroup = tag as CollapsibleGraphGroup | null;
    if (!graphGroup) {
      return IOrientedRectangle.EMPTY;
    }
    const availableWidth = nodeWidth + 2 * PADDING;
    const { tag: graphTag } = this.graph;
    const { groupHeaders } = graphTag as YGraphState;
    const groupHeader = ensureHeaderLayout(node, groupHeaders);
    if (!groupHeader) {
      return IOrientedRectangle.EMPTY;
    }
    const { mainLabelHeight, subLabelHeight } = groupHeader;

    const stripeBottom =
      nodeY + 2 * PADDING + Math.max(mainLabelHeight, EXPANDER_SIZE);
    const x = nodeX + PADDING;
    const y = stripeBottom + PADDING;

    return new OrientedRectangle(
      new Rect(x, y, availableWidth, subLabelHeight)
    );
  }
}
export { GroupSubLabelModel };
